import { useNuxtApp } from '#app';
import { onMounted } from 'vue';
import { useSetI18nParams } from '#i18n';

/**
 * Keep the documented per-page SEO options after i18n 10.5's final head update.
 * That update runs on app:rendered/app:mounted and otherwise restores global
 * query settings, losing the canonicalQueries passed to useSetI18nParams.
 */
export function useSeoI18nParams(options) {
  const nuxtApp = useNuxtApp();
  const setParams = useSetI18nParams(options);
  let currentParams = {};
  const apply = () => setParams(currentParams);
  const ownerPath = nuxtApp.$router.currentRoute.value.path;
  // i18n #4129: an outgoing detail watcher may write its params onto the
  // incoming route during Suspense. Reassert this mounted page's own map once
  // the handover is complete, without changing library internals or other pages.
  onMounted(() => {
    if (
      !nuxtApp.isHydrating &&
      nuxtApp.$router.currentRoute.value.path === ownerPath
    )
      apply();
  });
  if (import.meta.server || nuxtApp.isHydrating) {
    const unhook = nuxtApp.hook(
      import.meta.server ? 'app:rendered' : 'app:mounted',
      () => {
        apply();
        unhook();
      }
    );
  }
  return (params) => {
    currentParams = params;
    apply();
  };
}
